import { Container } from "./styles";

export default function BoxCircle(props: any) {
    return (
        <Container {...props}>
            {props.children}
        </Container>
    );
}